import memoize from 'memoizee';
import { arrayToHashmap, flattenArray } from '@/utils/Array';
import pools from '@/constants/pools';

const getMainPoolsGaugeRewards = memoize(async () => (
    (await fetch('https://api.curve.finance/api/getMainPoolsGaugeRewards')).json()
), {
    promise: true,
    maxAge: 5 * 60 * 1000, // 5 min
});

const getCurveRewards = async () => {
    // Map the new api extra rewards info format to the old format until expanding the refactoring
    // to all chains
    const { data: { mainPoolsGaugeRewards } } = await getMainPoolsGaugeRewards();
    const additionalRewardsPerGauge = arrayToHashmap(pools.map(({
        addresses: { gauge },
        additionalRewards,
    }) => gauge ? [gauge.toLowerCase(), additionalRewards] : null).filter((o) => o !== null));

    return arrayToHashmap(flattenArray(Array.from(Object.entries(mainPoolsGaugeRewards)).map(([gaugeAddress, gaugeRewards]) => (
        gaugeRewards.map(({
            apy,
            tokenAddress,
            symbol,
            tokenPrice,
        }) => {
            const additionalRewards = additionalRewardsPerGauge[gaugeAddress.toLowerCase()];
            const additionalReward = additionalRewards.find(({ rewardTokenAddress, name }) => (
                rewardTokenAddress ?
                    rewardTokenAddress.toLowerCase() === tokenAddress.toLowerCase() :
                    name === symbol
            ));
            const keyOrName = additionalReward?.key || additionalReward?.name || symbol;

            return [keyOrName, {
                rewards: apy,
                price: tokenPrice,
            }]
        })
    ))));
}

export default getCurveRewards;
